import React from "react";
import {
  fmt,
  isOrientationCandidate,
  orientationLabel,
  stabilityLabel,
} from "./needsApplicationModel";

export default function ResultantStrip({ state }) {
  const candidate = isOrientationCandidate(state);
  const convergence = Number(state?.convergence);
  const safe = Number.isFinite(convergence) ? Math.max(0, Math.min(1, convergence)) : null;

  if (candidate) {
    return (
      <section className="v25a-resultant-strip candidate">
        <div>
          <span className="v25a-eyebrow">ORIENTATION CANDIDATE</span>
          <b>{orientationLabel(state?.orientation)}</b>
          <small>Én-root eller ellers ikke promotert til multi-root resultant.</small>
        </div>
        <div className="v25a-candidate-line" aria-hidden="true">
          <i /><i /><i /><span>›</span>
        </div>
      </section>
    );
  }

  return (
    <section className="v25a-resultant-strip">
      <div className="v25a-resultant-copy">
        <span className="v25a-eyebrow">RESULTANT FIELD</span>
        <b>{orientationLabel(state?.orientation)}</b>
        <small>Capability-relative · {stabilityLabel(state?.stability_class)}</small>
      </div>

      <div className="v25a-resultant-axis">
        <span>Mer constraining</span>
        <div className="v25a-axis-track">
          <i style={{ left: `${safe === null ? 50 : safe * 100}%` }} />
        </div>
        <span>Mer affording</span>
      </div>

      <div className="v25a-resultant-metrics">
        <span>convergence <b>{fmt(state?.convergence)}</b></span>
        <span>divergence <b>{fmt(state?.divergence)}</b></span>
        <span>balance <b>{fmt(state?.balance)}</b></span>
      </div>
    </section>
  );
}
